<template>
  <div class="body">
    <div class="main_container">
      <!-- <training-header :appConfig = "appConfig"  ></training-header> -->

      <!-- page content -->
      <div class="right_col" role="main" style="margin-left: 2px;">
        <!--            CUSTOM PROGESS INDICATOR - START    -->

        <div class="row px-4 pt-4">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_content">
                <div class="process_steps">
                  <ul class="steps">
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Download</span>
                      </div>
                    </li>
                    <li class="active">
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Customize</span>
                      </div>
                    </li>
                    <!-- <li>
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Upload</span>
                      </div>
                    </li> -->
                    <li>
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span>Complete</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel">
              <div class="x_title">
                <h2
                  style="font-weight: 600;"
                >Facilitator, please customise your course to your local needs</h2>
                <div class="clearfix"></div>
              </div>
              <div class="x_content">
                <div class="dashboard-widget-content">
                  <table class="table table-bordered table-striped" style="font-size: 14px;font-weight: 600;">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Develop your agenda using the following resources</th>
                        <th>Select</th>
                        <th>Type of session</th>
                        <th>Recommended duration</th>
                        <th>Your selection of duration</th>
                      </tr>
                    </thead>
                    <tbody v-if="facilitatorObj.agenda">
                      <template v-for="(agenda, i) in facilitatorObj.agenda" >
                      <tr :key="i">
                        <td>{{i+1}}</td>
                        <td>{{agenda.agenda}}</td>
                        <td style="text-align:  center;">
                          <input type="checkbox"
                          :value="agenda.masterAgendaId"
                          :id="agenda.masterAgendaId"
                          v-model="agendaSelected"
                          @change="getSelected(agenda.masterAgendaId, $event)">
                        </td>
                        <td>{{agenda.typeOfSession}}</td>
                        <td>{{agenda.recommendedDuration}}</td>
                        <td>
                          <select :id="agenda.masterAgendaId" name="basiccontime" class="form-control" @change="getDuration($event)">
                            <!-- <option>Select minutes</option> -->
                            <option :value="d" v-for="d in duration" :key="d">{{d}} min</option>
                          </select>
                        </td>
                      </tr>
                      </template>
                    </tbody>
                  </table>

                  <div>
                    <div class="row">
                      <!--                                           <a href="agenda_word_doc.html" class="btn btn-primary btn-md btn3d btnNextClick" role="button" style="float: right;margin-right: 102px;">Submit</a>-->
                    </div>

                    <div style="text-align: center; margin-bottom: 3%;margin-top: 1%; padding-bottom:5%;">

                      <router-link :to="{ name: 'resources-session', params: { facilitatorObj: facilitatorObj ,appConfig: appConfig}}"   class="btn-bottom" style="margin-right: 5%;">
                        <i
                          class="fa fa-angle-double-left"
                          aria-hidden="true"
                          style="padding-right: 1%;"
                        ></i> Previous
                      </router-link>
                      <!--                                            <a href="upload_agenda_word_doc.html" class="btn btn-danger btn-md btn3d">Next</a>-->
                      <a
                        href="#"
                        class="btn-bottom btnNextClick"
                        role="button"
                        style="color: #3471CE;"
                        @click="checkAgenda"
                      >
                        Next
                        <i
                          class="fa fa-angle-double-right"
                          aria-hidden="true"
                          style="padding-left: 1%;"
                        ></i>
                      </a>

                      <!-- <a href="login.html" class="btn btn3d btn-cust1" role="button">Skip to Login</a> -->

                      <!--                                    <a href="login.html" class="btn btn-cust1 btn-md btn3d" role="button">Skip to Login</a>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <!-- <training-footer :appConfig="appConfig"></training-footer> -->
      <!-- /footer content -->
    </div>
  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import ApiServices from '../service/ApiServices';
import swal from 'sweetalert2';
export default {
    components: {
        trainingHeader,
        trainingFooter
    },
    data(){
      return {
        facilitatorObj:{},
        appConfig:{},
        duration: [15, 30, 45, 60, 75, 90, 105, 120],
        masterAgenda: null,
        agendaSelected: [],
        selectedAgendas: [],
        selectedAgendasArr: [],
        durationSelected: 15,
        obj: null
      }
    },
    methods:{
      getUserAgenda(){
        this.$root.loading = true;
        ApiServices.RestPostCall('api/avenir/training/getMasterAgenda',{}).then(res=>{
            this.$root.loading = false;
            this.masterAgenda = res.masterAgenda
            localStorage.setItem("masterAgenda",JSON.stringify(this.masterAgenda));
        })
      },
      getSelected(id, e){
        if(e.target.checked){
          this.obj = {masterAgendaId: id, duration: 15, selected: true}
          this.selectedAgendas.push(this.obj)
        }else{
          this.selectedAgendas = this.selectedAgendas.filter(function(el) {
          return el.agendaId != id; });
        }
        localStorage.setItem("selectedAgendas",JSON.stringify(this.selectedAgendas));
      },
      getDuration(e){
        //console.log(e.target.value, event.target.id, this.agendaSelected)
        this.durationSelected = e.target.value
        let id = event.target.id, duration = e.target.value, obj = {}, selectedArr = []
        this.obj = {agendaId: id, duration: this.durationSelected, selected: true}

        let objIndex = this.selectedAgendas.findIndex((obj => obj.agendaId == id));
        if(objIndex != -1){
          this.selectedAgendas[objIndex].duration = this.durationSelected
        }
        localStorage.setItem("selectedAgendas",JSON.stringify(this.selectedAgendas));
      },
      checkAgenda(){
        if(this.selectedAgendas.length > 0){
        //  this.$router.push("/agenda-doc");
            this.$router.push({ name: 'agenda-doc', params: { facilitatorObj: this.facilitatorObj,appConfig: this.appConfig } })
        }else{
          Swal.fire({
            text: "Please select atleast one course!",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
          })
        }
      }
    },
    mounted(){
      //this.getUserAgenda()
      if(this.$route.params.facilitatorObj){
      this.facilitatorObj = this.$route.params.facilitatorObj
    }
      if(this.$route.params.appConfig){
      this.appConfig = this.$route.params.appConfig
      }
    }
}
</script>
<style scoped>
    .x_panel {
        background-color: #fff;
        border: 0px solid transparent;
        padding:0;
        border-radius: 7px;
    }
    .x_title {
        border-bottom: 0px solid #E6E9ED;
        padding: 15px 18px;
        background-color: #b0b0b0;
        color: #fff;
        border-radius: 7px 7px 0 0;
    }
    .x_content {
        padding: 0 25px 6px;
    }
    .table-bordered td{
      font-weight: 400;
    }
</style>
